//"use client";

import AboutGallery from "../components/AboutGallery"
import TextAbout from "../components/CoverAboutPage"




const AboutPage = () =>{

    return(
        <div className="container pt-5">
            

              <TextAbout/>

                <AboutGallery/>
        </div>
    )

}

export default AboutPage